<template>
  <div class="footer-box">
    <el-row>
      <!-- 公司标识及公司名称 left -->
      <el-col :span="8" :offset="3">
        <div class="left-box">
          <div class="logo">
            <img src="@/assets/logo.png" alt="诚优佳(北京)装饰工程有限公司" width="220" height="64">
          </div>
          <div class="slogan">信誉诚 · 质量优 · 服务佳</div>
          <div class="company">Copyright©2010-{{ y }} 诚优佳(北京)装饰工程有限公司</div>
        </div>
      </el-col>
      <!-- 施工案例 ，联系我们 right -->
      <el-col :span="13">
        <el-row>
          <!-- 联系我们 -->
          <el-col :span="12">
            <div class="case">
              <div class="title" style="display: flex; justify-content: space-between; align-items: center; mar">
                <span>行业/新闻</span>
                <!-- <i class="el-icon-arrow-right" style="color: #999; margin-right: 20px; cursor: pointer;"></i> -->
              </div>
              <el-row class="case-lists">
                <el-col :span="22">
                  <div class="line-a" v-for="(item, index) in newsList">
                    <a :href="'/news?id=' + item.id" target="_blank">{{ item.title }} </a>
                  </div>
                </el-col>
                <!-- <el-col :span="10" :offset="1">
                  <div><span>-</span> 商场装修工程</div>
                  <div><span>-</span> 售楼处装修工程</div>
                  <div><span>-</span> 医院装修</div>
                  <div><span>-</span> ········</div>
                </el-col> -->
              </el-row>
            </div>
          </el-col>
          <!-- 联系我们 -->
          <el-col :span="12">
            <div class="contact-us">
              <div class="title">联系我们</div>
              <div class="img-text">
                <img src="../assets/icon/phone.png" alt="13381161376" srcset="" width="20" height="20">
                <span>电话：<b>400-888-9908</b></span>
              </div>
              <div class="img-text">
                <img src="../assets/icon/email.png" alt="13381161376" srcset="" width="20" height="20">
                <span>邮箱：chengyoujiazs@126.com</span>
              </div>
              <div class="img-text">
                <img src="../assets/icon/address.png" alt="13381161376" srcset="" width="20" height="20">
                <span>地址：北京市石景山区泽洋大厦710室</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <h3 style="color: #333; margin-top: 20px;">友情链接</h3>
              <div style="font-size: 14px;">
                <a style="color: #333;" href="https://www.gousizhe.com" target="_blank">构思者科技</a>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <div class="beian">
            <a href="https://www.beian.miit.gov.cn/" target="_blank">京ICP备19037652号-1</a>
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getNewsList } from '@/api/news';
const year = new Date().getFullYear()
export default {
  name: 'Footer',
  data() {
    return {
      y: year,
      newsList: []

    }
  },

  mounted() {
    getNewsList({
      page: 1,
      pageSize: 5
    }).then(res => {
      console.log('sss', res)
      this.newsList = res.data.list
    })
  }

}
</script>
<style scoped lang="scss">
.logo {
  margin-bottom: 108px;
}

.slogan {
  font-weight: 400;
  font-size: 36px;
  color: #D5AF8E;
  margin-bottom: 142px;
}

@media (max-width: 1440px) {
  .logo {
    margin-bottom: 88px !important;
  }

  .slogan {
    margin-bottom: 100px !important;
  }
}

.company {
  font-weight: 400;
  font-size: 14px;
  color: #3F3F3F;
}


.footer-box {
  background-image: url(@/assets/images/fotter_bg.png);
  padding: 70px 0;
}

.title {
  font-weight: 400;
  font-size: 24px;
  color: #3F3F3F;
  margin-bottom: 50px;
}

.contact-us {
  line-height: 36px;

  .img-text {
    display: flex;
    align-items: center;

    img {
      margin-right: 8px;
    }

    b {
      font-size: 30px;
      color: #AD7F5A;
    }
  }
}

.case-lists {
  display: flex;
  line-height: 36px;

  span {
    color: #D5AF8E;
  }

  .list-letf {
    margin-right: 86px;
  }
}

.beian {
  font-size: 14px;
  margin-top: 42px;

  a {
    color: #333;
  }
}

@media (min-width: 1601px) {
  .beian {
    margin-top: 140px;
  }
}

@media (min-width: 1921px) {
  .beian {
    margin-top: 140px;
  }
}

@media (min-width: 1441px) {
  .beian {
    margin-top: 102px;
  }
}

.line-a {
  /* single-line text truncation with ellipsis */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* ensure the container has a width (it will naturally fill its parent) */
  display: block;
  font-size: 15px;
  line-height: 29px !important;

  a {
    color: #3f3f3f;
  }

  a:hover {
    color: #3858da;
  }
}
</style>
